export default __webpack_public_path__ + "static/media/logo-nav.c194ed30.png";